import getPref from '../../OneHat/functions/getPref';
import setPref from '../../OneHat/functions/setPref';
import { decode } from 'html-entities';
import _ from 'lodash';

const Questions = {
	
	name: 'Questions',
	model: {

		idProperty: 'questions__id',
		displayProperty: 'questions__display_as',

		sorters: [
			{
				name: 'questions__sort_order',
				direction: 'ASC',
			}
		],
		
		properties: [
 			{ name: 'questions__id',	mapping: 'id',	type: 'int', },
			{ name: 'questions__display_as',	mapping: 'display_as', },
			{ name: 'questions__q',	mapping: 'q', },
			{ name: 'questions__a',	mapping: 'a', },
			{ name: 'questions__next',	mapping: 'next',	type: 'int', },
			{ name: 'questions__prev',	mapping: 'prev',	type: 'int', },
			{ name: 'questions__next_in_full',	mapping: 'next_in_full',	type: 'int', },
			{ name: 'questions__sort_order',	mapping: 'sort_order',	type: 'int', },
			{ name: 'questions__division_id',	mapping: 'division_id',	type: 'int', },
			{ name: 'questions__volume_id',	mapping: 'volume_id',	type: 'int', },
			{ name: 'questions__ordinal',	mapping: 'ordinal', },
			{ name: 'questions__is_gated',	mapping: 'isGated',	type: 'bool',	defaultValue: false, }, // put there by controller, based on purchased items
	
			{ name: 'divisions__id',	mapping: 'division.id',	type: 'int', },
			{ name: 'divisions__name',	mapping: 'division.name', },
			{ name: 'divisions__volume_id',	mapping: 'division.volume_id',	type: 'int', },
			{ name: 'divisions__parent_id',	mapping: 'division.parent_id',	type: 'int', },
			{ name: 'divisions__next',	mapping: 'division.next',	type: 'int', },
			{ name: 'divisions__prev',	mapping: 'division.prev',	type: 'int', },
			{ name: 'divisions__sort_order',	mapping: 'division.sort_order',	type: 'int', },
		
			{ name: 'volumes__id',	mapping: 'volume.id',	type: 'int', },
			{ name: 'volumes__name',	mapping: 'volume.name', },
			{ name: 'volumes__sort_order',	mapping: 'volume.sort_order',	type: 'int', },
		],

		associations: {

			hasMany: [
				'Proofs',
				'Songs',
			],
			belongsTo: [
				'Volumes',
				'Divisions',
			],

		},

	},

	entity: {
		methods: {

			getProofs: function() {
				const Proofs = this.getAssociatedRepository('Proofs');
				return Proofs.getBy((entity) => {
					return entity.proofs__question_id === this.questions__id;
				});
			},

			getProofsString: function() {
				const proofs = this.getProofs(),
					strings = _.map(proofs, (proof) => {
						return proof.getString();
					});
				return strings.join("\n");
			},

			getSongs: function() {
				const Songs = this.getAssociatedRepository('Songs');
				return Songs.getBy((entity) => {
					return entity.songs__question_id === this.questions__id;
				});
			},

			getVolume: function() {
				const Volumes = this.getAssociatedRepository('Volumes');
				return Volumes.getById(this.questions__volume_id);
			},

			getDivision: function() {
				const Divisions = this.getAssociatedRepository('Divisions');
				return Divisions.getById(this.questions__division_id);
			},
			
			getVoxSong: function(is_alt = false) {
				const Songs = this.getAssociatedRepository('Songs');
				return Songs.getVoxSong(this, is_alt);
			},

			getNovoxSong: function(is_alt = false) {
				const Songs = this.getAssociatedRepository('Songs');
				return Songs.getNovoxSong(this, is_alt);
			},

			getHasAlt: function() {
				const Songs = this.getAssociatedRepository('Songs');
				const song = Songs.getVoxSong(this, true);
				return !!song;
			},

			getIsAlt: function() {
				const pref = getPref('is_alt-' + this.id);
				return pref === 'true';
			},

			saveIsAlt: function(bool) {
				setPref('is_alt-' + this.id, bool);
			},
			
		},
	},

	repository: {
		type: 'lfr',
		local: {
			type: 'async',
			isPaginated: false,
			autoSave: true,
			methods: {
				decodeHtmlEntities: function () {
					const entities = this.entities;
					_.each(entities, (entity) => {
						entity.questions__display_as = decode(entity.questions__display_as);
						entity.questions__q = decode(entity.questions__q);
						entity.questions__a = decode(entity.questions__a);
						entity.divisions__name = decode(entity.divisions__name);
					});
				},

				getNonGated: function() {
					return this.getBy((question) => {
						return !question.questions__is_gated;
					});
				},
			},
		},
		remote: {
			type: 'onebuild',
			isPaginated: false,
			autoSave: false,
		},
	},

};

export default Questions;
